import React, { Component } from "react";
import BootstrapCarousel from "./BootstrapCarousel";

class SlideProfessor extends Component {
  state = {
    controls: true,
    indicators: true,
    pauseOnHover: true,
    interval: 3000,
    nextIcon: <img alt="seta slide esquerda" src="images/arrow_right.png" />,
    prevIcon: <img alt="seta slide direita" src="images/arrow_left.png" />,
    slides: [
      {
        id: 0,
        idSlide: "slide5_img1",
        imgSrc: "images/slide5_img1.png",
        video: "https://www.youtube.com/embed/gLBWKmelo7g?autoplay=1",
        altImg: "First slide Fifth caroussel",
      },
      {
        id: 1,
        idSlide: "slide5_img2",
        imgSrc: "images/slide5_img2.png",
        video: "https://www.youtube.com/embed/7zPU4tahvKY?autoplay=1",
        altImg: "Second slide Fifth caroussel",
      },
      {
        id: 2,
        idSlide: "slide5_img3",
        imgSrc: "images/slide5_img3.png",
        video: "https://www.youtube.com/embed/Bnj0Ehm1Z-4?autoplay=1",
        altImg: "Third slide Fifth caroussel",
      },
      {
        id: 3,
        idSlide: "slide5_img4",
        imgSrc: "images/slide5_img4.png",
        video: "https://www.youtube.com/embed/IKvTeW4SiWw?autoplay=1",
        altImg: "Fourth slide Fifth caroussel",
      },
    ],
  };
  render() {
    const {
      controls,
      indicators,
      pauseOnHover,
      interval,
      slides,
      nextIcon,
      prevIcon,
    } = this.state;
    return (
      <div className="slide_container">
        <BootstrapCarousel
          controls={controls}
          indicators={indicators}
          pauseOnHover={pauseOnHover}
          interval={interval}
          slides={slides}
          nextIcon={nextIcon}
          prevIcon={prevIcon}
          openVideoModal={this.props.openVideoModal}
        />
        <div className="slide_hover"></div>
      </div>
    );
  }
}

export default SlideProfessor;
